var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { BarsBase, Bar } from './styled';
const variantMax = {
    risk: 7,
    sustainability: 10,
    custom: 20,
};
export function Bars(_a) {
    var { variant = 'risk', max = variantMax[variant], value, size = 'normal' } = _a, props = __rest(_a, ["variant", "max", "value", "size"]);
    if (max < 0 || value > max) {
        // eslint-disable-next-line no-console
        console.warn(`
      The property "value" of the bars component must
      be within 0 and ${max}, but was [${value}].
    `);
        return null;
    }
    const filled = Array(value)
        .fill('')
        .map((_, i) => `bars-filled-${i}`);
    const empty = Array(max - value)
        .fill('')
        .map((_, i) => `bars-empty-${i}`);
    return (React.createElement(BarsBase, Object.assign({ role: "meter", "aria-label": `${variant} level` }, props, { "aria-valuenow": value, "aria-valuetext": value.toString(), "aria-valuemax": max }),
        filled.map((key) => (React.createElement(Bar, { key: key, "$filled": true, "$variant": variant, "$size": size }))),
        empty.map((key) => (React.createElement(Bar, { key: key, "$variant": variant, "$size": size })))));
}
export default Bars;
